import { render, staticRenderFns } from "./OurCasino.vue?vue&type=template&id=5ef1eadc&scoped=true"
import script from "./OurCasino.vue?vue&type=script&lang=js"
export * from "./OurCasino.vue?vue&type=script&lang=js"
import style0 from "./OurCasino.vue?vue&type=style&index=0&id=5ef1eadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef1eadc",
  null
  
)

export default component.exports